/* AYLINAS — Our Story: reveal animations, scroll-to-next and carousels */
(function () {
  if (window.__aylinasStory) return;
  window.__aylinasStory = true;
  var d = document;
  d.documentElement.classList.add('ays-js', 'ays-ready');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  var io = (!reduce && !design && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }) : null;
  function init(scope) {
    var els = (scope || d).querySelectorAll('.ays-anim:not(.is-in)');
    for (var i = 0; i < els.length; i++) { if (io) io.observe(els[i]); else els[i].classList.add('is-in'); }
  }
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var s = t.closest('[data-ays-scroll]');
    if (s) {
      e.preventDefault();
      var sec = s.closest('.shopify-section');
      var nx = sec ? sec.nextElementSibling : null;
      while (nx && !nx.offsetHeight) nx = nx.nextElementSibling;
      if (nx) {
        var target = nx.querySelector('.ays, .ayv') || nx;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        var h = target.querySelector('h1, h2');
        if (h) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (err) {} }
      }
      return;
    }
    var b = t.closest('[data-ays-prev],[data-ays-next]');
    if (b) {
      var car = b.closest('[data-ays-car]');
      var tr = car && car.querySelector('[data-ays-track]');
      if (tr) tr.scrollBy({ left: (b.hasAttribute('data-ays-prev') ? -1 : 1) * tr.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' });
    }
  });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
